import LineNotifyHome from './pages/LineNotifyHome'
import LineNotifyNotice from './pages/LineNotifyNotice'
import LineNotifyUser from './pages/LineNotifyUser'
import LineNotifyAdd from './pages/LineNotifyAdd'

// LINE Notify Routing
export const lineNotifyRoute = {
  name: 'LineNotify',
  path: 'line-notify',
  component: LineNotifyHome,
  redirect: {
    name: 'LineNotifyNotice'
  },
  children: [
    {
      name: 'LineNotifyNotice',
      path: '',
      component: LineNotifyNotice
    },
    {
      name: 'LineNotifyUser',
      path: 'user',
      component: LineNotifyUser
    },
    {
      name: 'LineNotifyAdd',
      path: 'add',
      component: LineNotifyAdd
    },
  ]
}


// WEBPACK FOOTER //
// ./src/features/managements/modules/line-notify/routes.js